var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAIicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.458,
    height: 40.188,
    viewBox: "0 0 31.458 40.188",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4520",
    "data-name": "Group 4520",
    transform: "translate(-594.92 -5951.054)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_227",
    "data-name": "Union 227",
    d: "M4.092,39.188a4.132,4.132,0,0,1-3.06-1.04A4.207,4.207,0,0,1,0,35.058V15.573a4.228,4.228,0,0,1,1.033-3.1,4.12,4.12,0,0,1,3.06-1.046h6.162a6.019,6.019,0,0,1,1.9.254,4.024,4.024,0,0,1,1.523,1.041l6.928,7.04a5.1,5.1,0,0,1,.816,1.043A3.261,3.261,0,0,1,21.8,21.9a9.441,9.441,0,0,1,.1,1.465V35.058a4.221,4.221,0,0,1-1.028,3.09,4.127,4.127,0,0,1-3.066,1.04ZM2.811,14.256a1.958,1.958,0,0,0-.488,1.422V34.955a1.963,1.963,0,0,0,.482,1.426,1.922,1.922,0,0,0,1.442.5H17.633a1.728,1.728,0,0,0,1.947-1.923V23.6H12.441a2.626,2.626,0,0,1-1.934-.646,2.643,2.643,0,0,1-.646-1.946V13.754h-5.6A1.932,1.932,0,0,0,2.811,14.256Zm9.137,6.5a.637.637,0,0,0,.741.742H19.21l-7.262-7.376Zm13.059-.484a1.946,1.946,0,0,0-1.947-1.946,1.168,1.168,0,0,1,0-2.336,1.947,1.947,0,0,0,1.947-1.946,1.168,1.168,0,0,1,2.336,0,1.946,1.946,0,0,0,1.946,1.946,1.168,1.168,0,0,1,0,2.336,1.946,1.946,0,0,0-1.946,1.946,1.168,1.168,0,1,1-2.336,0Zm.982-3.114.187.187.187-.187-.187-.187Zm-5.264-3.532a5.07,5.07,0,0,0-5.062-5.062,1.168,1.168,0,0,1,0-2.336,5.069,5.069,0,0,0,5.062-5.062,1.168,1.168,0,0,1,2.335,0,5.069,5.069,0,0,0,5.062,5.062,1.168,1.168,0,1,1,0,2.336,5.07,5.07,0,0,0-5.062,5.062,1.168,1.168,0,1,1-2.335,0ZM19.634,7.4a7.441,7.441,0,0,1,2.259,2.259A7.425,7.425,0,0,1,24.151,7.4a7.4,7.4,0,0,1-2.258-2.258A7.42,7.42,0,0,1,19.634,7.4Z",
    transform: "translate(595.42 5951.554)",
    fill: "#333",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAIicon);
export default __webpack_public_path__ + "static/media/AIicon.de1c0dbfcc0b9ee6ae86f3fa40e323f5.svg";
export { ForwardRef as ReactComponent };